export const enum LABELS {
    PROCEED_AND_PAY = "proceed-and-pay",
    REVIEW_ORDER = "review-order",
    REVIEW_CART = "review-cart",
    REVIEW_IM_CART = "review-im-cart",
    DISMISS = "dismiss",
    BANNER = "banner",
    PROCEED = "Proceed",
    ONE_TAP_UPI = "1-tap-upi",
}
